'use client'

import { useEffect } from 'react'
import { useAuthenticate } from 'core/components/Authenticate'

// issue: https://stackoverflow.com/questions/58830752/gtag-js-user-id-config-vs-set

export default function GoogleAnalytics({ children }: { children: React.ReactNode }) {
  const { loginData } = useAuthenticate()

  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      // Initialize GA4
      window.gtag('config', process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || '', {
        send_page_view: true,
      })
    }
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag && loginData?.fid) {
      window.gtag('set', {
        user_id: loginData.fid,
      })
    }
  }, [loginData])

  return <>{children}</>
}
